import { Directive, ElementRef, Input, OnChanges, AfterViewInit } from '@angular/core';

interface IParameterIconDisable {
    index: number,
    parameter_type: string,
    query_type: number,
    action: 'delete' | 'add'
}

@Directive({
    // tslint:disable-next-line: directive-selector
    selector: '[parameterIconDisable]'
})
export class ParameterIconDisableDirective implements OnChanges, AfterViewInit {
    private el: HTMLElement;

    @Input('parameterIconDisable') data: IParameterIconDisable;

    constructor(el: ElementRef) {
        this.el = el.nativeElement;
    }

    ngAfterViewInit(): void {
        this.handleDisable();
    }

    ngOnChanges() {
        this.handleDisable();
    }

    private handleDisable() {
        if (this.needsDisable()) {
            this.el.setAttribute('disabled', 'true');
        } else {
            this.el.removeAttribute('disabled')
        }
    }

    private needsDisable() {
        if (this.data.parameter_type === '3' && this.data.action === 'delete') {
            return true;
        }

        if (this.data.query_type == 6) {
            if (this.data.action === 'delete' && this.data.index <= 1) {
                return true;
            }
            if (this.data.action === 'add' && this.data.index === 0) {
                return true;
            }
        }

        return false;
    }
}
